import { FC, ReactElement } from 'react';

import { AzureMapStyleWrapper } from './AzureMapCustomization.styled';
import { useAzureMapCustomization } from './hooks/useAzureMapCustomization';

type AzureMapCustomizationProps = {
  children: ReactElement;
};

export const AzureMapCustomization: FC<AzureMapCustomizationProps> = ({
  children
}) => {
  useAzureMapCustomization();

  return <AzureMapStyleWrapper>{children}</AzureMapStyleWrapper>;
};
